import { useEffect, useState } from 'react'

import { getBuildingsNG } from '../../../../api'
import { EMPTY_LIST } from '../../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../constants/pagination'
import { SIZE } from '../../../../constants/size'
import { useNotification } from '../../../../hooks'
import { getItemsIds } from '../../../../utils/common'
import { toBuildingSelectItems } from '../../../Building'
import { FormModal } from '../../../Form'

import {
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS,
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_QA_NAME,
} from './EntityTabBuildingsEditModal.constants'
import {
  getEntityTabBuildingsEditModalActionTypes,
  getEntityTabBuildingsEditModalInitialValues,
  getEntityTabBuildingsEditModalOptionsFilter,
  getEntityTabBuildingsEditModalValidationSchema,
} from './EntityTabBuildingsEditModal.utils'
import { FormFields } from './FormFields'

function EntityTabBuildingsEditModal({
  scopeFilterKey,
  scopeId,
  onClose,
  onSubmit,
}) {
  const { handleAddErrorNotification } = useNotification()

  const [initialValues, setInitialValues] = useState(
    getEntityTabBuildingsEditModalInitialValues(EMPTY_LIST)
  )
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getBuildingsNG({
      ...getEntityTabBuildingsEditModalOptionsFilter({
        scopeFilterKey,
        scopeId,
      }),
      size: PAGINATION_ALL_ITEMS_SIZE,
    })
      .then(({ data }) => {
        setInitialValues(
          getEntityTabBuildingsEditModalInitialValues(
            toBuildingSelectItems(data.items)
          )
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [scopeId])

  function handleSubmit({ values }) {
    onSubmit({
      buildingIds: getItemsIds(
        values[ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS],
        'value'
      ),
    })
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: ENTITY_TAB_BUILDINGS_EDIT_MODAL_QA_NAME,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{
        actionTypes: getEntityTabBuildingsEditModalActionTypes(),
        isLoading,
      }}
      formTitle='Modal.EditBuildingsTitleKey'
      initialValues={initialValues}
      validationSchema={getEntityTabBuildingsEditModalValidationSchema(
        initialValues
      )}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default EntityTabBuildingsEditModal
